module.exports = __webpack_public_path__ + "img/checkin_at_airport.04a8a3b4.png";